module.exports = __webpack_public_path__ + "static/media/MaryProbst.15ba3235.png";